<template>
  <el-dialog
      :visible.sync="dialogVisibility"
      width="30%"
      center>
    <div slot="title">
      <strong>Device </strong>{{ device.mac_address || device.hardware_id }}
    </div>
    <div
        style="text-align: center; font-size: initial">
      <div style="margin-bottom: 5px">
        Redirecting to <strong>Ring Solutions</strong> in <strong>{{ timer }}</strong> seconds
      </div>
      <el-button
          type="text"
          @click="openNewTab">
        <span style="font-size: initial">cancel and open in a new tab</span>
      </el-button>
    </div>
    <span
        slot="footer"
        class="dialog-footer">
      <el-button
          type="info"
          size="medium"
          @click="cancel">Cancel</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "RingSolutionsRedirectDialog",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    device: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timer: 100,
      intervalId: null,
    };
  },
  computed: {
    dialogVisibility: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("update:open", value);
      },
    },
  },
  watch: {
    timer(value) {
      if (value < 1) {
        this.stopTimer();
        this.$emit("update:open", false);
        location.href = this.device.ring_solutions_url;
      }
    },
    open(value) {
      if (value === true) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    },
  },
  created() {
    this.startTimer();
  },
  methods: {
    openNewTab() {
      this.stopTimer();
      this.closeDialog();
      window.open(this.device.ring_solutions_url, "_blank");
    },
    cancel() {
      this.closeDialog();
    },
    closeDialog() {
      this.dialogVisibility = false;
    },
    stopTimer() {
      this.timer = 10;
      clearInterval(this.intervalId);
    },
    startTimer() {
      this.timer = 10;
      this.intervalId = setInterval(() => {
        this.timer = this.timer - 1;
      }, 1000);
    },
  },
};
</script>

<style scoped></style>
